<div class="row" style="margin-top: 10px;">
  <div class="col-12">
    <div class="card">
      <div class="card-header"  *ngIf="campoPesquisa">
        <div class="card-tools" style="margin-bottom: 10px;">

          <div *ngIf="camposFiltro" class="input-group input-group-sm" style="width: 350px;">
            <input type="text" name="table_search" (keyup)="buscarLista()" [(ngModel)]="termoBusca" class="form-control float-right" placeholder="{{placeHolder}}">
            <div class="input-group-append">
              <button *ngIf="filtro" class="btn btn-danger btn-default" (click)="limparFiltro()">
                <i class="fa fa-eraser text-white"></i>
              </button>
              <button *ngIf="!filtro" type="submit" class="btn btn-primary btn-default">
                <i class="fa fa-search text-white"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body table-responsive p-0" >
        <table  class="table table-hover table-borderless table-head-fixed table-striped text-nowrap">
          <thead style="z-index: 1 !important;position: relative;">
          <tr>
            <th *ngIf="checkSelecionar"></th>
            <th *ngFor="let item of colunas; let i = index" [hidden]="i === 0">{{item}}</th>
            <th style="width: 20px" *ngIf="botaoEditar||botaoDeletar">*</th>
          </tr>
          </thead>
          <tbody *ngIf="!filtro && linhas.length > 0">
          <tr  *ngFor="let linha of linhas | paginate: { itemsPerPage: 10, currentPage: paginaAtual }">
            <td *ngIf="checkSelecionar"><input type="checkbox" id="checkBoxSelecionar" value="{{linha[0]}}"></td>
            <td *ngFor="let itemLinha of linha; let i = index" [hidden]="i === 0">{{itemLinha}}</td>
            <td *ngIf="botaoEditar"><a href="{{linkBotaoEditar}}/{{linha[0]}}"> <button class="btn btn-warning"><i class="fa fa-edit"></i></button></a></td>
            <td *ngIf="botaoDeletar"><button (click)="deletar(linha[0])"  class="btn btn-danger"><i class="fa fa-trash"></i></button></td>
          </tr>
          <tr *ngIf="linhas.length == 0">
            <td colspan="10" class="text-center text-orange">Nenhum registro a ser mostrado</td>
          </tr>
          </tbody>
          <tbody *ngIf="filtro && listaFiltrada.length > 0">
          <tr *ngFor="let linha of listaFiltrada | paginate: { itemsPerPage: 10, currentPage: paginaAtual }">
            <td *ngIf="checkSelecionar"><input type="checkbox" id="checkBoxSelecionar" value="{{linha[0]}}"></td>
            <td *ngFor="let itemLinha of linha; let i = index" [hidden]="i === 0">{{itemLinha}}</td>
            <td *ngIf="botaoEditar"><a href="{{linkBotaoEditar}}/{{linha[0]}}"> <button class="btn btn-warning"><i class="fa fa-pencil"></i></button></a></td>
            <td *ngIf="botaoDeletar"><button (click)="deletar(linha[0])" class="btn btn-danger"><i class="fa fa-trash"></i></button></td>
          </tr>
          <tr *ngIf="listaFiltrada.length == 0">
            <td colspan="10" class="text-center text-orange">Nenhum registro encontrado</td>
          </tr>
          </tbody>
          <tfoot>
          <tr class="text-center">
            <td [attr.colspan]="quantidadeColunas +1">
              <pagination-controls class="pagination-sm"
                                   [autoHide]="false"
                                   [directionLinks]="true"
                                   previousLabel="Anterior"
                                   nextLabel="Próximo"
                                   (pageChange)="pageChange($event)">
              </pagination-controls>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
